module.exports = __webpack_public_path__ + "static/media/Shadow-PNG-Pic3.2e5aa504.png";